import { render } from "./highSeas.vue?vue&type=template&id=30c3fda1&scoped=true"
import script from "./highSeas.vue?vue&type=script&lang=js"
export * from "./highSeas.vue?vue&type=script&lang=js"

import "./highSeas.vue?vue&type=style&index=0&id=30c3fda1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30c3fda1"

export default script